// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerContent":"Footer_footerContent__E5RXg","mapContainer":"Footer_mapContainer__PrSvR"};